var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-sidebar-wrapper" }, [
    _c("div", { staticClass: "page-sidebar navbar-collapse collapse" }, [
      _c(
        "ul",
        {
          staticClass: "page-sidebar-menu  page-header-fixed ",
          staticStyle: { "padding-top": "20px", "padding-bottom": "16px" },
          attrs: {
            "data-keep-expanded": "false",
            "data-auto-scroll": "true",
            "data-slide-speed": "200"
          }
        },
        [
          _c(
            "Auth",
            {
              attrs: {
                authority: [
                  _vm.$USER_TYPE.beginner,
                  _vm.$USER_TYPE.intermediate,
                  _vm.$USER_TYPE.advanced
                ]
              }
            },
            [
              _c("li", { staticClass: "nav-item menu-label" }, [
                _c("i", { staticClass: "fa fa-th-large" }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [_vm._v("功能")])
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  attrs: {
                    to: { name: "project" },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("主题包管理")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "project"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  attrs: {
                    to: { name: "miniapp" },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("小程序管理")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "miniapp"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  attrs: {
                    to: { name: "material" },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("素材管理")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "material"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Auth",
            { attrs: { authority: [_vm.$USER_TYPE.super] } },
            [
              _c("li", { staticClass: "nav-item menu-label" }, [
                _c("i", { staticClass: "fa fa-th-large" }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [_vm._v("审核")])
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  class: { "open active": _vm.mainMenu == "pending" },
                  attrs: {
                    to: { name: "projectCheck", params: { type: "pending" } },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("待审核主题包")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "pending"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  class: { "open active": _vm.mainMenu == "audit" },
                  attrs: {
                    to: { name: "projectCheck", params: { type: "audit" } },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("已审核主题包")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "audit"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  class: { "open active": _vm.mainMenu == "miniappPending" },
                  attrs: {
                    to: { name: "miniappCheck", params: { type: "pending" } },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("待审核小程序专题")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "miniappPending"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-item",
                  class: { "open active": _vm.mainMenu == "miniappAudit" },
                  attrs: {
                    to: { name: "miniappCheck", params: { type: "audit" } },
                    tag: "li",
                    "active-class": "open active"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link nav-toggle",
                      attrs: { href: "javascript:void(0)" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("已审核小程序专题")
                      ]),
                      _vm._v(" "),
                      _vm.mainMenu == "miniappAudit"
                        ? _c("span", { staticClass: "selected" })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "Admin",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-item",
                      attrs: {
                        to: { name: "shared" },
                        tag: "li",
                        "active-class": "open active"
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link nav-toggle",
                          attrs: { href: "javascript:void(0)" }
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("已共享主题包")
                          ]),
                          _vm._v(" "),
                          _vm.mainMenu == "shared"
                            ? _c("span", { staticClass: "selected" })
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "nav-item",
              attrs: {
                to: { name: "profile" },
                tag: "li",
                "active-class": "open active"
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link nav-toggle",
                  attrs: { href: "javascript:void(0)" }
                },
                [
                  _c("span", { staticClass: "title" }, [_vm._v("账号设置")]),
                  _vm._v(" "),
                  _vm.mainMenu == "setting"
                    ? _c("span", { staticClass: "selected" })
                    : _vm._e()
                ]
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item menu-label" }, [
      _c("i", { staticClass: "fa fa-gear" }),
      _vm._v(" "),
      _c("span", { staticClass: "title" }, [_vm._v("设置")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }